<template>

  <li
    class="
          first-line
          fw-700
          fs-16
          lh-18
          flex flex-row
          items-center
          pt-8
          pb-8
          "
    v-for='(item) in aboutUsContent' :key='item'>
    <img
      :src= item.src
      alt=""
      class="mr-12"
    />
    <div>
      <div class="mb-0 ">
        <div v-if="hasTitle" v-html="item.title"></div>
        <div v-html="item.text"></div>
      </div>

    </div>
  </li>
</template>
<script>
import {assetCDN} from '~/helper/index.js';

export default {
  props: {

    hasTitle: {
      type: Boolean,
      default: true
    },


  },
  setup() {
    const ASSETS_CDN = assetCDN()
    const aboutUsContent = [
      {src:`${ASSETS_CDN}/icons/location.svg`, title:'<p class="fs-20 fw-700 lh-28 tl-fs-16 tl-lh-24 mb-0">Locally Designed, Globally Adored</p>',text:'<p class="mb-fs-14 mb-lh-20 fs-16 lh-24 tl-fs-14 tl-lh-20 fw-400 mb-0">Backed by <b class="fw-700">270+</b> expert local designers.</p>'},
      {src:`${ASSETS_CDN}/icons/car.svg`, title:'<p class="fs-20 fw-700 lh-28 tl-fs-16 tl-lh-24 mb-0">Book with Confidence</p>',text:'<p class="mb-fs-14 mb-lh-20 fs-16 lh-24 tl-fs-14 tl-lh-20 fw-400 mb-0"><b class="fw-700">1,900+</b> travellers have booked with us.</p>'},
      {src:`${ASSETS_CDN}/icons/favorite.svg`,title:'<p class="fs-20 fw-700 lh-28 tl-fs-16 tl-lh-24 mb-0">Travel with Confidence</p>',text:'<p class="mb-fs-14 mb-lh-20 fs-16 lh-24 tl-fs-14 tl-lh-20 fw-400 mb-0">Rated <b class="fw-700">9.4/10</b> by past travellers.</p>'}
    ]
    return {
      aboutUsContent
    }
  }

}
</script>
